import { List, ListProps, SearchInput } from 'react-admin';
import { AppResponsive } from 'shared/components/common/AppResponsive.component';
import { MembershipDisplayTable } from '../components/MembershipDisplayTable.component';

export function MembershipDisplayList(
  props: ListProps & { allowExtendedOfferInfo: boolean }
) {
  const table = (
    <MembershipDisplayTable
      omitItems={props.allowExtendedOfferInfo ? [] : ['payload']}
    />
  );
  return (
    <List
      {...props}
      perPage={25}
      filters={[<SearchInput source='search' alwaysOn />]}
      exporter={false}
    >
      <AppResponsive xs={table} sm={table} md={table} lg={table} xl={table} />
    </List>
  );
}
